export const cabecerasTabla = [
    {
        titulo: "IDENTIFICADOR",
        esBotonera: false,
        funcionOrdenacion: null,
        id: "identificadorId",
    },
    {
        titulo: "EXPEDIDOR",
        esBotonera: false,
        funcionOrdenacion: null,
        id: 'expedidor',
    },
    {
        titulo: "TIPO DE CERTIFICADO",
        esBotonera: false,
        funcionOrdenacion: null,
        id: 'tipoCertificado',
    },
]

export const objetoDatos = [
    {
        identificadorId: "Notifica",
        expedidor: "FNMT",
        tipoCertificado: "Sello de entidad",
    },
    {
        identificadorId: "Dirección General de Investigación y Transferencia del Conocimiento",
        expedidor: "Firma Profesional",
        tipoCertificado: "Sello de órganos",
    },
    {
        identificadorId: "Notifica",
        expedidor: "Firma Profesional",
        tipoCertificado: "Sello de órganos",
    },
    {
        identificadorId: "Dirección General de Comercio",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
    {
        identificadorId: "Dirección General de Economía Digital e Innovación",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
    {
        identificadorId: "Secretaría General de de Empresa, Innovación y Emprendimiento",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
    {
        identificadorId: "Secretaría General de Industria y Minas",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
    {
        identificacion: "Secretaría General de Universidades, Investigación y Tecnología",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
    {
        identificadorId: "Secretaría General Técnica",
        expedidor: "FNMT",
        tipoCertificado: "Sello electrónico",
    },
]

export const keysTablaGenerica = {
    urlImg: 'img',
    keyTitulo: 'titulo',
    onClickFunction: 'funcion'
}

export const texts = {
    PAGE_TITLE: 'Relación de los sellos electrónicos y sistemas de firma',
    ID_PAGE_TITLE : 'tituloPagina',
}